import type { HostProductCodeDto } from "../../types/HostProductCodeDto";
import type { HostProductCodeEntity } from "../../types/HostProductCodeEntity";

export const HostProductCodeEntityToDto = ({ ...rest }: Readonly<HostProductCodeEntity>): HostProductCodeDto => {
    return { ...rest };
};
